var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M109.804,449.487H24.976C11.182,449.487,0,438.305,0,424.511V53.278 c0-13.794,11.182-24.976,24.976-24.976h84.828c13.794,0,24.976,11.182,24.976,24.976v371.234 C134.779,438.305,123.597,449.487,109.804,449.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M28.079,179.995V68.867c0-6.897,5.591-12.488,12.488-12.488h53.646 c6.897,0,12.488,5.591,12.488,12.488v111.128c0,6.897-5.591,12.488-12.488,12.488H40.567 C33.67,192.483,28.079,186.892,28.079,179.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M85.161,420.255H49.619c-10.345,0-18.732-8.386-18.732-18.732v-35.542 c0-10.345,8.386-18.732,18.732-18.732h35.542c10.345,0,18.732,8.386,18.732,18.732v35.542 C103.892,411.868,95.506,420.255,85.161,420.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M95.515,412.546H56.204c-9.305,0-16.847-7.542-16.847-16.847v-39.311 c0-2.865,0.782-5.522,2.044-7.884c-6.161,2.506-10.514,8.532-10.514,15.593v39.311c0,9.305,7.543,16.847,16.847,16.847h39.311 c6.44,0,11.968-3.654,14.803-8.963C99.89,412.088,97.758,412.546,95.515,412.546z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 44.925,
    y: 116.012,
    style: {
      fill: "#64798A"
    },
    width: 44.925,
    height: 16.846
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.925,
    y: 82.313,
    style: {
      fill: "#64798A"
    },
    width: 44.925,
    height: 16.846
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.925,
    y: 149.704,
    style: {
      fill: "#64798A"
    },
    width: 44.925,
    height: 16.846
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M443.317,449.487h-84.828c-13.794,0-24.976-11.182-24.976-24.976V53.278 c0-13.794,11.182-24.976,24.976-24.976h84.828c13.794,0,24.976,11.182,24.976,24.976v371.234 C468.293,438.305,457.111,449.487,443.317,449.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M361.592,179.995V68.867c0-6.897,5.591-12.488,12.488-12.488h53.646 c6.897,0,12.488,5.591,12.488,12.488v111.128c0,6.897-5.591,12.488-12.488,12.488H374.08 C367.183,192.483,361.592,186.892,361.592,179.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M418.674,420.255h-35.542c-10.345,0-18.732-8.386-18.732-18.732v-35.542 c0-10.345,8.386-18.732,18.732-18.732h35.542c10.345,0,18.732,8.386,18.732,18.732v35.542 C437.406,411.868,429.019,420.255,418.674,420.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M429.028,412.546h-39.311c-9.305,0-16.847-7.542-16.847-16.847v-39.311 c0-2.865,0.782-5.522,2.044-7.884c-6.161,2.506-10.514,8.532-10.514,15.593v39.311c0,9.305,7.543,16.847,16.847,16.847h39.311 c6.44,0,11.968-3.654,14.803-8.963C433.404,412.088,431.272,412.546,429.028,412.546z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 378.443,
    y: 116.012,
    style: {
      fill: "#64798A"
    },
    width: 44.925,
    height: 16.846
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.443,
    y: 82.313,
    style: {
      fill: "#64798A"
    },
    width: 44.925,
    height: 16.846
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.443,
    y: 149.704,
    style: {
      fill: "#64798A"
    },
    width: 44.925,
    height: 16.846
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M239.359,448.706l-83.539-14.73c-13.584-2.395-22.654-15.349-20.259-28.933l64.464-365.594 c2.395-13.584,15.349-22.654,28.933-20.259l83.539,14.73c13.584,2.395,22.654,15.349,20.259,28.933l-64.464,365.594 C265.897,442.031,252.943,451.101,239.359,448.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M205.673,169.117l19.297-109.44c1.198-6.792,7.675-11.327,14.467-10.13l52.831,9.315 c6.792,1.198,11.327,7.675,10.13,14.467l-19.297,109.44c-1.198,6.792-7.675,11.327-14.467,10.13l-52.831-9.315 C209.01,182.386,204.475,175.909,205.673,169.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M220.167,415.638l-35.002-6.172c-10.188-1.796-16.991-11.512-15.194-21.7l6.172-35.002 c1.796-10.188,11.512-16.991,21.7-15.194l35.002,6.172c10.188,1.796,16.991,11.512,15.194,21.7l-6.172,35.002 C240.07,410.632,230.355,417.435,220.167,415.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M231.702,409.845l-38.713-6.826c-9.163-1.616-15.282-10.353-13.666-19.517l6.826-38.713 c0.498-2.822,1.729-5.302,3.382-7.409c-6.502,1.398-11.836,6.577-13.062,13.53l-6.826,38.713 c-1.616,9.163,4.503,17.901,13.666,19.517l38.713,6.826c6.342,1.118,12.421-1.52,16.135-6.257 C236.09,410.154,233.911,410.234,231.702,409.845z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 245.611,
    y: 98.765,
    transform: "matrix(-0.1736 0.9848 -0.9848 -0.1736 417.5324 -107.8966)",
    style: {
      fill: "#64798A"
    },
    width: 16.846,
    height: 44.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.446,
    y: 65.578,
    transform: "matrix(-0.1736 0.9848 -0.9848 -0.1736 391.6978 -152.5924)",
    style: {
      fill: "#64798A"
    },
    width: 16.846,
    height: 44.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.764,
    y: 131.943,
    transform: "matrix(-0.1736 0.9848 -0.9848 -0.1736 443.3442 -63.1987)",
    style: {
      fill: "#64798A"
    },
    width: 16.846,
    height: 44.925
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.74e8164646e4ed411d4c8d70621d8edb.svg";
export { ForwardRef as ReactComponent };